// Venue time-slot definitions. Mirror of backend/time_slots.py.
//
// Venue providers who set an `other_events` price can host TWO bookings per
// day for non-wedding events:
//   - SLOT_MORNING : 08:00 – 13:00
//   - SLOT_EVENING : 14:00 – 21:00
// Wedding-tier bookings always reserve the full day.

export const SLOT_MORNING = 'morning';
export const SLOT_EVENING = 'evening';

export const TIME_SLOTS = [
  { key: SLOT_MORNING, label: 'Morning', time: '8 AM – 1 PM', range: '08:00–13:00' },
  { key: SLOT_EVENING, label: 'Evening', time: '2 PM – 9 PM', range: '14:00–21:00' },
];

export const WEDDING_TIER_EVENTS = ['marriage', 'engagement', 'reception', 'wedding'];

export const isWeddingEvent = (eventType) =>
  !!eventType && WEDDING_TIER_EVENTS.includes(String(eventType).toLowerCase());

export const getSlotLabel = (key) => {
  const s = TIME_SLOTS.find((t) => t.key === key);
  return s ? `${s.label} (${s.time})` : '';
};
